__turbopack_context__.v({
  "breadcrumbs": "r-zBNG_breadcrumbs",
  "buttonApply": "r-zBNG_buttonApply",
  "buttonBack": "r-zBNG_buttonBack",
  "buttonBackIcon": "r-zBNG_buttonBackIcon",
  "buttonReset": "r-zBNG_buttonReset",
  "container": "r-zBNG_container",
  "description": "r-zBNG_description",
  "explanation": "r-zBNG_explanation",
  "explanationButton": "r-zBNG_explanationButton",
  "explanationButtonIcon": "r-zBNG_explanationButtonIcon",
  "explanationList": "r-zBNG_explanationList",
  "explanationTitle": "r-zBNG_explanationTitle",
  "footer": "r-zBNG_footer",
  "footerInfo": "r-zBNG_footerInfo",
  "header": "r-zBNG_header",
  "headerContainer": "r-zBNG_headerContainer",
  "hideBigScreen": "r-zBNG_hideBigScreen",
  "listWords": "r-zBNG_listWords",
  "listWordsSection": "r-zBNG_listWordsSection",
  "listWordsSectionHeader": "r-zBNG_listWordsSectionHeader",
  "loader": "r-zBNG_loader",
  "pageContainer": "r-zBNG_pageContainer",
  "right": "r-zBNG_right",
  "section": "r-zBNG_section",
  "sectionTitle": "r-zBNG_sectionTitle",
  "showBigScreen": "r-zBNG_showBigScreen",
  "switchList": "r-zBNG_switchList",
  "title": "r-zBNG_title",
  "type": "r-zBNG_type",
  "visibleExplanation": "r-zBNG_visibleExplanation",
});
